import { CurrencyLgComponent } from './currency-lg/currency-lg.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseCurrencyComponent } from './base-currency.component';
import { CurrencyXsComponent } from './currency-xs/currency-xs.component';
import { CurrencySmComponent } from './currency-sm/currency-sm.component';
import { CurrencyMdComponent } from './currency-md/currency-md.component';
import { CurrencyComponent } from './currency/currency.component';

@NgModule({
  declarations: [
    BaseCurrencyComponent,
    CurrencyXsComponent,
    CurrencySmComponent,
    CurrencyMdComponent,
    CurrencyLgComponent,
    CurrencyComponent,
  ],
  exports: [
    BaseCurrencyComponent,
    CurrencyXsComponent,
    CurrencySmComponent,
    CurrencyMdComponent,
    CurrencyLgComponent,
    CurrencyComponent,
  ],
  imports: [CommonModule],
})
export default class CurrencyModule {}
